import 'css-chunksrc/client/scenes/constrainElement/styles.scss';export default {
  "constrainElement": "_constrainElement_6rjys_1",
  "row": "_row_6rjys_8",
  "col": "_col_6rjys_18",
  "text": "_text_6rjys_25",
  "buttons": "_buttons_6rjys_31"
};